import { useLocation, useNavigate } from '@tanstack/react-router';

export const useNavigateToOriginLocation = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const originLocation = location.state?.originLocation;

    return () => {
        if (originLocation) {
            navigate({ to: originLocation.pathname, search: originLocation.search, state: originLocation.state });
        } else {
            navigate({ to: '/dashboard' });
        }
    };
};
